import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { AppConst } from 'src/app/core/_constants/app.constant';
import { RouteConstant } from 'src/app/core/_constants/route.constant';
import { CommonService } from 'src/app/core/_services/common.service';
import { MainService } from 'src/app/core/_services/main.service';
import { LocalStorageProvider } from 'src/app/core/_services/storage.service';
import { ChoosePaymentComponentComponent } from '../../dialogs/choose-payment-component/choose-payment-component.component';
import { MatDialog } from '@angular/material/dialog';
import { PaymentsComponent } from '../../dialogs/payments/payments.component';
import { PaymentStyleComponent } from '../../dialogs/payment/payment.component';

@Component({
  selector: 'app-work-order',
  templateUrl: './work-order.component.html',
  styleUrls: ['./work-order.component.scss']
})
export class WorkOrderComponent implements OnInit {
  dateFormat = AppConst.DATE_FORMAT;
  @Input() preview: any;
  @Input() orders: any;
  @Input() review: any;
  @Input() page: any;
  @Input() hidePrice: any;
  @Input() lumpSum: any;

  @Input() payFlag: boolean = false;
  @Input() totalAmount: any;
  @Input() details: any;
  @Input() set expandBundleId(id: string) {
    if (id) {
      this.expandedBundles.add(id);
    }
  }
  @Output() changesHappend = new EventEmitter<boolean>();

  @Output() payRejected = new EventEmitter<boolean>();


  fileUrl: any;
  fileBuffer: any;
  id: string;
  taxAmount: any;
  totalAmountPaid: any = 0;
  discountAmount: number = 0;
  constructor(private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private loader: NgxUiLoaderService,
    private toastr: ToastrService,
    private storageService: LocalStorageProvider,
    private service: MainService,
    private dialog: MatDialog
  ) {

  }
  ngOnChanges(change: SimpleChange): void {
    // if(change['orders']?.currentValue){
    //   this.totalAmount = this.calculateAmount('total');
    // }
    console.log(this.details, 'this is details')

    if (this.orders && this.orders.length) {
      this.orders.forEach(element => {
        if (!element.isBundle) {
          element['total'] = (+element['price'] * (+element['quantity'])) + Number(element['tax'])
        }
      });
    }
    this.totalTax(this.orders)
    this.totalAmount = this.calculateAmount('total')
    this.taxAmount = this.calculateAmount('tax')
    this.discountAmount = this.calculateDiscount()

    if (change['payFlag']?.currentValue) {
      this.openPaymentPopUp();
    }
  }

  isPreferredUser: boolean = false;
  userProfile: any;
  isOnlinePayAvailable: boolean = false;
  ngOnInit(): void {
    this.isPreferredUser = this.storageService.getItem('CurrentUser')?.externalCompanyData?.isPreferred;
    console.log(this.details, 'this is details')
    this.getParams();
    this.getDefaultStatus();
    this.userProfile = this.storageService.getItem('CurrentUser');
    if (this.userProfile?.companyData?.valorPaytechObj?.appId && this.userProfile?.activePaymentGateway === 'VALOR') {
      this.isOnlinePayAvailable = true;
    } else if (this.userProfile?.runPaymentsObj?.auth?.publicKey && this.userProfile?.activePaymentGateway === 'RUNPAYMENTS') {
      this.isOnlinePayAvailable = true;
    }
  }
  inspectionBtn: any = []
  getDefaultStatus() {
    this.service.get({}, `${API_ROUTES.OPPORTUNITY.getInspectionBtnStatus}`).pipe().subscribe(response => {
      console.log(response)
      if (response.status) {
        let initialData = response.data?.list;
        this.inspectionBtn = response.data?.list;
        this.orders?.forEach((estimate) => {
          const foundEstimate = initialData.find((initial) => initial._id === estimate.inspectionId);
          if (foundEstimate) {
            estimate.inspectionStatus = foundEstimate.fieldName;
          }
        });
      }
    })
  }
  calculateAmount(key: any) {
    let total = 0.00;
    if (this.orders) {
      this.orders.map((order: any) => {

        total = total + this.amountFor(order, key);
      });
      return total.toFixed(2);
    }
    return 0.00;
  }

  // ================= Discount (read-only) =================
  // Work orders carry discountAmount / discountedTax / discountedTotal when a discount was applied.
  // A bundle is treated as one item: its discount is on the bundle row, not on the child items.
  // Old work orders without these fields keep using their own tax / total.

  private hasDiscount(order: any): boolean {
    return Number(order?.discountAmount) > 0;
  }

  woDiscount(order: any): number {
    return this.hasDiscount(order) ? Number(order.discountAmount) || 0 : 0;
  }

  woTax(order: any): number {
    return this.hasDiscount(order) ? Number(order.discountedTax) || 0 : parseFloat(order?.tax) || 0;
  }

  woTotal(order: any): number {
    return this.hasDiscount(order) ? Number(order.discountedTotal) || 0 : parseFloat(order?.total) || 0;
  }

  private amountFor(order: any, key: string): number {
    if (key === 'total') return this.woTotal(order);
    if (key === 'tax') return this.woTax(order);
    return parseFloat(order?.[key]) || 0;
  }

  private calculateDiscount(): number {
    if (!this.orders) return 0;
    const sum = this.orders.reduce((acc: number, order: any) => acc + this.woDiscount(order), 0);
    return Number(sum.toFixed(2));
  }

  /**
   * Amount owed.
   * No discount: the backend's totalAmount, exactly as before.
   * With a discount: the discounted total of the work orders.
   */
  get grandTotal(): number {
    if (this.discountAmount > 0) {
      return Number(this.totalAmount) || 0;
    }
    return Number(this.details?.totalAmount) || 0;
  }

  /** Subtotal before discount = (total - tax) + discount */
  get subtotalBeforeDiscount(): number {
    return this.grandTotal - (Number(this.taxAmount) || 0) + (this.discountAmount || 0);
  }


  getParams() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        this.id = params['oppId'] ? params['oppId'] : params['jobId'];
      }
    })
  }

  showImages(images: any) {
    this.commonService.openImageSliderModal(images)
  }

  reviewWorkOrder() {
    this.storageService.setItem('Orders', this.orders)
    this.router.navigate([`${RouteConstant.WorkOrderDetail}`], { queryParamsHandling: "merge", relativeTo: this.activatedRoute })
  }

  viewOrder(order: any) {
    this.commonService.setActiveEstimate(order);
  }
  setStatusStyle(status: any) {
    switch (status) {
      case 'Approved':
        return 'green-btn';
      case 'Completed':
        return 'blue-btn';
      case 'Not_Started':
        return 'grey-btn';
      case 'Started':
        return 'light-green-btn';
      case 'Paused':
        return 'orange-btn';
      default:
        return 'red-btn';
    }
  }

  callApi() {
    if (this.fileBuffer) {
      this.download();
      return;
    }
    this.loader.start();
    const data = {
      oppId: this.id,
      previewType: 'workOrder'
    }
    this.service.getPDF(data, `${API_ROUTES.OPPORTUNITY.previewWorkOrder}`).subscribe({
      next: (response: Blob) => {
        const fileURL = window.URL.createObjectURL(response);

        const link = document.createElement('a');

        link.href = fileURL;

        link.download = 'work_order.pdf';

        link.click();

        window.URL.revokeObjectURL(fileURL);
      },
      error: (err) => {
        this.loader.stop();
        this.toastr.error(err?.msg || 'Download failed');
      },
      complete: () => this.loader.stop()
    })
  }

  download() {
    // Create a link element for downloading the file
    const downloadLink: any = document.createElement('a');
    downloadLink.href = this.fileUrl;
    downloadLink.download = 'work_order.pdf';
    // Trigger a click event on the link to download the file
    downloadLink.click();
    this.loader.stop();
  }

  formatText(val, precision) {
    console.log(val)
    if (val) {
      return Number(val).toFixed(precision)
    }
    return 0.00
  }
  totalTaxAmount: any;
  totalTax(order) {

    if (this.details?.work_order_data) {
      this.totalTaxAmount = this.details?.work_order_data.reduce((acc, item) => {
        return acc + this.woTax(item);
      }, 0);
    }
    console.log(this.totalTaxAmount)

  }
  openPaymentPopUp() {
    if (this.grandTotal - Number(this.details?.totalAmountPaid) <= 0) {
      this.toastr.error('You have already reached the payment limit.')
    }
    else {
      if (!this.isOnlinePayAvailable) {
        this.toastr.error('The payment processor has not been configured for this company. Kindly contact the designated contact person.');
        return;
      }
      const data = {
        totalAmount: this.totalAmount,
        balanceRemaining: this.grandTotal - Number(this.details?.totalAmountPaid),
        payment: Number(this.totalAmountPaid),
        oppId: this.id,
        operDetails: this.details
      }

      const dialogRef = this.dialog.open(PaymentStyleComponent, {
        maxHeight: '100vh',
        width: '700px',
        maxWidth: '100%',
        disableClose: true,
        data: {
          type: 2,
          data: data
        }
      })
      dialogRef.afterClosed().subscribe((confirm: any) => {
        console.log(confirm, '1')
        if (confirm !== undefined && confirm !== null && confirm) {
          this.getJobDetails(this.id)

        } else {
          this.payRejected.emit(false);
        }
      });
    }
  }
  getJobDetails(id: any) {
    this.changesHappend.emit(true);
    // const data = {
    //   oppId: id
    // }
    // this.loader.start();
    // this.service.get(data, `${API_ROUTES.OPPORTUNITY.getOpportunityDetails}`).pipe().subscribe(response => {
    //   if (response.status) {
    //     this.details = response?.data[0];
    //     this.loader.stop()

    //   } else {
    //     this.toastr.error(response.msg);
    //   }
    //   this.loader.stop();

    // })
  }
  expandedBundles: Set<string> = new Set();
  getItemNumber(i: number): number {
    let count = 0;
    for (let j = 0; j <= i; j++) {
      count++;  // every entry (bundle or regular) counts as 1
    }
    return count;
  }
  /**
   * Toggle a bundle's expanded/collapsed state.
   * Called when the user clicks a bundle header row.
   */
  toggleBundle(bundleInstanceId: string): void {
    // if (this.expandedBundles.has(bundleInstanceId)) {
    //   this.expandedBundles.delete(bundleInstanceId);
    // } else {
    //   this.expandedBundles.add(bundleInstanceId);
    // }
  }

  /**
   * Returns true if the given bundle is currently expanded.
   * Used by *ngIf in the template to show/hide child rows.
   */
  isBundleExpanded(bundleInstanceId: string): boolean {
    return this.expandedBundles.has(bundleInstanceId);
  }

  onDragStarted(): void {
    // Collapse all expanded bundles when drag begins
    this.expandedBundles.clear(); // or whatever your expanded state is
  }
}
